import { Component } from '@angular/core';

@Component({
    selector: 'nio-migration-multi-national-financial-organization',
    templateUrl: './migration-multi-national-financial-organization.component.html',
    styleUrls: [
        './migration-multi-national-financial-organization.component.scss',
    ],
    standalone: false
})
export class MigrationMultiNationalFinancialOrganizationComponent {}
